import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 0267FB77-EB23-41D4-92B4-FF65796BDF40
 * name square-medium
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square-medium.svg
 * tags
 * - Shape 
 */
export const SquareMediumIcon = createSvgIcon(<><path d="M16,8H8V16H16V8Z" /></>, 'SquareMediumIcon');
export default SquareMediumIcon